import React from 'react';
import icon from '../img/info.svg';
import arrow from '../img/circle-arrow-left.svg';

class KindOfNoticeInput extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            choice: props.kindOf
        }
    }

    render() {
        const props = this.props;
        const { choice } = this.state;

        return (
            <article className={`question q2 slide-${props.position}`}>
                <div className={`inner`}>
                    <div className="question__text">
                        <span>Handelt es sich um eine außerordentliche bzw. fristlose Kündigung?</span>
                    </div>
                    <div className="question__field">
                        <select 
                            value={choice}
                            tabIndex="1"
                            onChange={(e) => this.setState({ choice: parseInt(e.target.value, 10) })}>
                                <option value="">Bitte wählen</option>
                                <option value="1">Ja</option>
                                <option value="2">Nein</option>
                        </select>
                    </div>
                </div>
                <div className="inner question__controls">
                    <div className="question__control">
                        <a tabIndex="3"
                            className="question__back-link" 
                            onClick={props.showPreviousField}>
                                <img src={arrow} />
                        </a>
                    </div>
                    <div className="question__control">
                        <span data-tip data-for="kind-of-notice" className="question__info-icon">
                            <img src={icon} />
                        </span>
                    </div>
                    <div className="question__control">
                        <a tabIndex={ choice ? "2" : "-1" }
                            onClick={() => props.updateKindOf(choice)}
                            className={`question__next-link ${!choice ? 'hidden' : ''}`}>
                                <img src={arrow} />
                        </a>
                    </div>
                </div>
            </article>
        );
    }
}

export default KindOfNoticeInput;


// WEBPACK FOOTER //
// ./src/components/input.kind-of-notice.js